  <!-- Breadcrumb -->
  <div class="content-breadcrumb div-breadcrumb">
    <em class="fa fa-medkit icon-breadcrumb"></em>
    <span class="text-breadcrumb">{{ tituloPagina }}</span>
  </div>
  <div class="container-fluid">
    <app-card titleCard="Assistência Médica Moura - Atendimento">
      <div class="row">
        <div class="col-12">
          <!-- <span class="dados-prestador text-warning">Esta guia deve ser impressa e entregue à Moura devidamente assinada e preenchida.</span><br> -->
          <span class="info-guia text-info">
            O titular/dependente deverá apresentar ao credenciado a <strong> carteira de Assistência Médica Moura </strong>juntamente com o documento de identificação (titular: documento com foto, RG, CNH, CTPS / dependente: Certidão de Nascimento, RG).
          </span> <br>

          <span class="info-guia text-info">
            Só terão direito a Assistência Médica Moura os filhos até 17 anos 11 meses e 29 dias.
          </span><br>

          <span class="info-guia text-info">
            Essa guia deverá ser impressa e entregue à Moura devidamente assinada e preenchida, evite glosas.
          </span><br>
          <span class="info-guia text-danger">
            Estamos com um novo formato de matricula, caso o paciente esteja com a matricula antiga, utilizar o CPF.
        </span><br>
        </div>
      </div>
      <form class="mt-4" autocomplete="off" #formGuiaMedica="ngForm" (ngSubmit)="saveGuia()">
        <ul class="list-group list-group-flush bt">
          <li class="list-group-item">
            <div class="row mt-2">
              <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-2">
                <input type="text" class="form-control" mask="00000000000" placeholder="Informe o CPF do funcionário"
                    name="cpfTitular" required [(ngModel)]="guiaMedica.cpfTitular" #cpfTitular="ngModel" [disabled]="disabledCPF"
                    (keyup)="buscarBeneficiarios($event.target.value)">
                  <app-message [control]="cpfTitular" error="required" text="CPF do titular é obrigatório!"></app-message>
              </div>
              <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-2">
                <input type="text" class="form-control" mask="0000000" placeholder="Informe a matrícula"
                    name="matricula" required [(ngModel)]="guiaMedica.matricula" #matricula="ngModel" [disabled]="disabledMatricula"
                    (keyup)="buscarBeneficiariosPorMatricula($event.target.value)">
                  <app-message [control]="matricula" error="required" text="Matrícula do titular é obrigatório!"></app-message>
              </div>
              <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-2">
                <ngx-select [items]="listaBeneficiarios" optionValueField="nome" optionTextField="nome" placeholder="Selecione o Beneficiário"
                  [disabled]="disabledBeneficiarios" noResultsFound="Nenhum resultado encontrado"
                  name="beneficiado" required [(ngModel)]="guiaMedica.beneficiado" #beneficiado="ngModel" (select)="selectBeneficiado($event)">
                </ngx-select>
                <app-message [control]="beneficiado" error="required" text="Campo obrigatório!"></app-message>
              </div>
              <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-2 align-self-center  ">
                <div class="">
                  <input type="checkbox" class="custom-checkbox" id="encaminhado" name="encaminhado" [(ngModel)]="guiaMedica.encaminhado">
                  <label class="label-encaminhamento ms-2 me-2" for="encaminhado">
                    <span class="text-danger">Guia Especial Moura</span>
                  </label>
                  <span class="ml-2 text-danger">
                    <i class="fa fa-info-circle"></i>
                  </span>
                </div>
            </div>
          </div>
          <!-- BLOCO DE ATENDIMENTOS DO TIPO PROCEDIMENTOS -->
          <div class="mt-2" [hidden]="listaBeneficiarios.length === 0">
            <button type="button" class="btn btn-info mt-2 mb-2 mr-2 me-2 text-white" (click)="modalNovoAtendimento(content)">
              <i class="fa fa-plus" aria-hidden="true"></i>&nbsp; Atendimento
            </button>
            <button type="button" class="btn btn-secondary mt-2 mb-2 text-white" (click)="modalNovoAtendimentoEstratificado(modalAtendimento)">
              <i class="fa fa-plus" aria-hidden="true"></i>&nbsp; Outros Tipos
            </button>
            <div class="table-responsive mt-3">
              <table class="table table-bordered table-hover text-center text-table">
                  <thead>
                      <tr class="table-active">
                          <th>Procedimento</th>
                          <th style="width: 70px">Quantidade</th>
                          <th style="width: 120px">Valor Unitário</th>
                          <th style="width: 90px">Ações</th>
                      </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let atendimento of listaAtendimentos; let i = index;">
                        <td>{{ atendimento.procedimento.nome }}</td>
                        <td>{{ atendimento.quantidade }}</td>
                        <td>R$ {{ atendimento.valorUnitario | number:'1.2-2' }}</td>
                        <td>
                            <a data-toggle="tooltip" title="Editar Procedimento">
                                <em class="fa fa-edit icon-table" (click)="modalEditarAtendimento(content, atendimento, i)"></em>
                            </a>&nbsp;
                            <a data-toggle="tooltip" title="Remover Procedimento">
                                <em class="fa fa-trash icon-table" (click)="modalRemoverAtendimento(contentRemove, i)"></em>
                            </a>
                        </td>
                    </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- BLOCO DE ATENDIMENTOS DO TIPO (MEDICAMENTO, MATERIAL, TAXAS E DIÁRIAS) -->
          <div class="mt-4" *ngIf="listaBeneficiarios.length !== 0 && listaAtendimentosEstratificados.length !== 0">
            <hr>
            <span class="label-encaminhamento">Lista de outros tipos de serviço: Medicamento, material, diária e taxas.</span>
            <div class="table-responsive mt-3">
              <table class="table table-bordered table-hover text-center text-table">
                  <thead>
                      <tr class="table-active">
                          <th>Nome</th>
                          <th style="width: 70px">Tipo</th>
                          <th style="width: 120px">Valor</th>
                          <th style="width: 90px">Ações</th>
                      </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let atendimento of listaAtendimentosEstratificados; let i = index;">
                        <td>{{ atendimento.nome }}</td>
                        <td>{{ atendimento.tipo }}</td>
                        <td>R$ {{ atendimento.valor | number:'1.2-2' }}</td>
                        <td>
                            <a data-toggle="tooltip" title="Editar Procedimento">
                                <em class="fa fa-edit icon-table" (click)="modalEditarAtendimentoEstratificado(modalAtendimento, atendimento, i)"></em>
                            </a>&nbsp;
                            <a data-toggle="tooltip" title="Remover Procedimento">
                                <em class="fa fa-trash icon-table" (click)="modalRemoverAtendimento(contentRemoveEst, i)"></em>
                            </a>
                        </td>
                    </tr>
                </tbody>
              </table>
            </div>
          </div>
        </li>
        <div class="row mt-2 pt-2 pb-2" [hidden]="!isVisible">
        <!-- <li class="list-group-item"> -->
          <div class="col">
            <span class="text-warning label-encaminhamento">Observação: Ao finalizar as modificações você deve clicar no botão 'Salvar Guia' para finalizar o processo.</span>
          </div>
          <div class="col-auto">
            <button type="submit" class="btn btn-success ms-2 me-2 float-right">
              <i class="fa fa-check" aria-hidden="true"></i>&nbsp; Salvar Guia
            </button>
            <button type="button" class="btn btn-secondary ms-2 me-2 float-right" routerLink="/atendimentos">
              <i class="fa fa-times" aria-hidden="true"></i>&nbsp; Cancelar
            </button>
          </div>
        </div>
      </ul>
    </form>
  </app-card>
    <!-- MODAL PARA CADASTRAR/ALTERAR OS ATENDIMENTOS -->
    <ng-template #content let-closed="close" let-dismiss="dismiss">
      <form #formAtendimento="ngForm" autocomplete="off" (ngSubmit)="salvarAtendimento(formAtendimento)">
          <div class="modal-personalizado-header">
            <span class="modal-personalizado-header-title">Atendimento</span>
            <button type="button" class="btn btn-primary mr-2 btn-fechar" (click)="dismiss('click')">
              <span aria-hidden="true">&times;</span>
           </button>
          </div>
          <div class="modal-body">
              <div class="row">
                <div class="col-12 col-sm-12 col-md-9 col-lg-9 mb-3">
                    <label class="required label-control">Procedimento</label>
                    <ngx-select ngbAutofocus [items]="listaProcedimentos" optionValueField="id" optionTextField="nome" placeholder="Procedimentos"
                        noResultsFound="Nenhum resultado encontrado" name="procedimento" required [(ngModel)]="atendimento.procedimentoId"
                        #atendimentoProcedimento="ngModel" (select)="searchProcedimentoValorUnitario($event)">
                    </ngx-select>
                    <app-message [control]="atendimentoProcedimento" error="required" text="Campo obrigatório!"></app-message>
                </div>

                <div class="col-12 col-sm-6 col-md-9 col-lg-3 mb-2">
                    <label class="required label-control"> Quantidade</label>
                    <ngx-select [items]="[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" noResultsFound="Nenhum resultado encontrado" [defaultValue]="1"
                      name="quantidade" required [(ngModel)]="atendimento.quantidade" #atendimentoQuantidade="ngModel">
                    </ngx-select>
                    <app-message [control]="atendimentoQuantidade" error="required" text="Campo obrigatório!"></app-message>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="dismiss('click')"> <i class="fa fa-times" aria-hidden="true"></i>&nbsp; Cancelar</button>
            <button type="submit" class="btn btn-primary" [disabled]="formAtendimento.invalid"> <i class="fa fa-check" aria-hidden="true"></i>&nbsp; Confirmar</button>
        </div>
      </form>
    </ng-template>

    <!-- MODAL DE CONFIRMAÇÃO PARA REMOVER UM ATENDIMENTO. -->
    <ng-template #contentRemove let-closed="close" let-dismiss="dismiss">
      <div class="modal-header">
        <div class="container row me-0 pe-0">
          <div class="col">
            <h4 class="modal-title" id="modal-title">Remover Atendimento</h4>
          </div>
          <div class="col-auto me-0 pe-0">
            <div class="d-flex justify-content-end">
              <button type="button" class="close" aria-label="Close button" aria-describedby="modal-title" (click)="dismiss('click')">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-body">
          <p><strong>Você tem certeza que deseja remover esse atendimento?</strong></p>
          <span class="text-danger">Esta operação não pode ser desfeita.</span>
      </div>
      <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" ngbAutofocus (click)="dismiss('click')">Cancelar</button>
          <button type="button" class="btn btn-danger" (click)="removerAtendimento(indexLista, 1)">Excluir</button>
      </div>
    </ng-template>

    <!-- MODAL PARA CADASTRAR/ALTERAR OS DADOS DO ATENDIMENTO ESTRATIFICADO -->
    <ng-template #modalAtendimento let-closed="close" let-dismiss="dismiss">
      <form #formAtendimentoEstratificado="ngForm" autocomplete="off" (ngSubmit)="salvarAtendimentoEstratificado(formAtendimentoEstratificado)">
          <div class="modal-personalizado-header">
              <span class="modal-personalizado-header-title">Atendimento</span>
              <button type="button" class="btn btn-primary mr-2 btn-fechar" (click)="dismiss('click')">
                <span aria-hidden="true">&times;</span>
             </button>
          </div>
          <div class="modal-body">
              <div class="row">
                <div class="col-12 mb-2">
                  <label class="required label-control">Nome</label>
                  <input ngbAutofocus type="text" class="form-control" placeholder="Informe um nome" name="nome" required [(ngModel)]="atendimentoEstratificado.nome" #atendimentoEstratificadoNome="ngModel">
                  <app-message [control]="atendimentoEstratificadoNome" error="required" text="Campo obrigatório"></app-message>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-12 col-sm-12 col-md-6 mb-2">
                  <label class="required label-control">Tipo</label>
                  <ngx-select [items]="['MEDICAMENTO', 'MATERIAL', 'TAXA', 'DIARIA', 'PROCEDIMENTO']" noResultsFound="Nenhum resultado encontrado"
                  [defaultValue]="'MEDICAMENTO'" name="tipo" required [(ngModel)]="atendimentoEstratificado.tipo" #atendimentoEstratificadoTipo="ngModel">
                  </ngx-select>
                  <app-message [control]="atendimentoEstratificadoTipo" error="required" text="Campo obrigatório!"></app-message>
                </div>
                <div class="col-12 col-sm-12 col-md-6 mb-2">
                  <label class="required label-control">Valor</label>
                  <input class="form-control" placeholder="R$ 0,00" required currencyMask name="valor" [(ngModel)]="atendimentoEstratificado.valor" #atendimentoEstratificadoValor="ngModel" [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"/>
                  <app-message [control]="atendimentoEstratificadoValor" error="required" text="Campo obrigatório"></app-message>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="dismiss('click')"> <i class="fa fa-times" aria-hidden="true"></i>&nbsp; Cancelar</button>
            <button type="submit" class="btn btn-primary" [disabled]="formAtendimentoEstratificado.invalid"> <i class="fa fa-check" aria-hidden="true"></i>&nbsp; Confirmar</button>
        </div>
      </form>
    </ng-template>

    <!-- MODAL DE CONFIRMAÇÃO PARA REMOVER UM ATENDIMENTO DO TIPO ESTRATIFICADO. -->
    <ng-template #contentRemoveEst let-closed="close" let-dismiss="dismiss">
      <div class="modal-header">
          <div class="container row me-0 pe-0">
            <div class="col">
              <h4 class="modal-title" id="modal-title">Remover</h4>
            </div>
            <div class="col-auto me-0 pe-0">
              <div class="d-flex justify-content-end">
                <button type="button" class="close" aria-label="Close button" aria-describedby="modal-title" (click)="dismiss('click')">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
          </div>
      </div>
      <div class="modal-body">
          <p><strong>Você tem certeza que deseja remover?</strong></p>
          <span class="text-danger">Esta operação não pode ser desfeita.</span>
      </div>
      <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" ngbAutofocus (click)="dismiss('click')">Cancelar</button>
          <button type="button" class="btn btn-danger" (click)="removerAtendimento(indexLista, 0)">Excluir</button>
      </div>
    </ng-template>
  </div>
